import { centsToDollars, parsePrice } from "helpers/price";

import { StyledNonCoveredContainer } from "../styled";

function NonCovered({ nonCoveredProcedures }: { nonCoveredProcedures: any }) {
  return (
    <StyledNonCoveredContainer className="flex flex-column w-full my-2">
      <p className="font-normal text-md red mb-2">Non-Covered Procedures</p>
      <div className="flex flex-column w-full gap-3">
        {nonCoveredProcedures.map((procedure: any, index: number) => (
          <div
            key={procedure.id}
            className="flex justify-content-between gap-2 px-2"
          >
            <p className="text-sm gray-text">{procedure.cptDescription}</p>
            <p className="text-sm highlighted font-medium">
              {parsePrice(centsToDollars(procedure.amountInCents))}
            </p>
          </div>
        ))}
      </div>
    </StyledNonCoveredContainer>
  );
}

export default NonCovered;
